import { render, staticRenderFns } from "./FooterButtons.vue?vue&type=template&id=1d21cb32&scoped=true"
import script from "./FooterButtons.vue?vue&type=script&lang=js"
export * from "./FooterButtons.vue?vue&type=script&lang=js"
import style0 from "./FooterButtons.vue?vue&type=style&index=0&id=1d21cb32&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d21cb32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d21cb32')) {
      api.createRecord('1d21cb32', component.options)
    } else {
      api.reload('1d21cb32', component.options)
    }
    module.hot.accept("./FooterButtons.vue?vue&type=template&id=1d21cb32&scoped=true", function () {
      api.rerender('1d21cb32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/FooterButtons.vue"
export default component.exports